
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// Plugin Vuex para persistir carrito en sessionStorage
const carritoPlugin = store => {
  // Restaurar al inicializar
  const saved = sessionStorage.getItem('carrito');
  if (saved) {
    try {
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed)) {
        store.state.carrito = parsed;
      }
    } catch (e) {
      // JSON corrupto — fallback a carrito vacío
      sessionStorage.removeItem('carrito');
    }
  }

  // Persistir en cada mutación que afecte al carrito
  store.subscribe((mutation) => {
    if (['agregarAlCarrito', 'quitarDelCarrito', 'actualizarCantidadCarrito', 'vaciarCarrito'].includes(mutation.type)) {
      sessionStorage.setItem('carrito', JSON.stringify(store.state.carrito));
    }
  });
};

export default new Vuex.Store({
  state: {
    usuario:{
      id:'',
      name:'',
      identificador:'',
      email:'',
      password:''
              },
    drawer:false,
    carrito:[],
    logueado: !!localStorage.getItem('token'),
    identificadorUsuario: localStorage.getItem('identificador') || '',
    linkPhotoUsuario: localStorage.getItem('linkPhoto') || '',
    userRoles: JSON.parse(localStorage.getItem('roles') || '[]'),
    items:[ 

         {text:'Ecommerce',to:'/ecommerce',icon:'mdi-store'},
         {text:'Foro',to:'/forum-admin',icon:'mdi-forum'},
         {text:'LinksTec',to:'/linkstec-admin',icon:'mdi-link-variant'},
         {text:'Admin General',to:'/admin-general',icon:'mdi-shield-account'},
      {text:'Cerrar Sessión',to:'/logout',icon:'mdi-logout'},
    ],
    itemsUsuario:[ 
    
      {text:'Mi cuenta',to:'/data_user',icon:'mdi-account-circle'},
      {text:'Mis Pedidos',to:'/mis-pedidos',icon:'mdi-clipboard-list'},
    //  {text:'Registrar Producto',to:'/register_producto_user',icon:'mdi-storefront'},
    // 
    //  {text:'Registro de Comprobantes',to:'/registro_comprobantes',icon:'mdi-account-circle'},
      // {text:'Login',to:'/login',icon:'mdi-account-circle'},
         {text:'About',to:'/about',icon:'mdi-account-circle'},
    
       ] 

       ,
    itemsStore:[ 
    
      // {text:'Home',to:'/store/all',icon:'mdi-home-circle'},
   //   {text:'Vendedor',to:'/perfil/magzoa',icon:'mdi-account-circle'},
    // 
    //  {text:'Registro de Comprobantes',to:'/registro_comprobantes',icon:'mdi-account-circle'},
      // {text:'Login',to:'/login',icon:'mdi-account-circle'},
       {text:'Blog',to:'/blog',icon:'mdi-post-outline'},
       {text:'About',to:'/about-store',icon:'mdi-page-next'},
    
       ] 
  },
  getters:{
    links:(state)=>{
      const roles = state.userRoles;
      // Mapeo: qué roles pueden ver cada ruta del menú admin
      const routeRoleMap = {
        '/ecommerce': ['admin', 'seller'],
        '/forum-admin': ['admin', 'author'],
        '/linkstec-admin': ['admin', 'links'],
        '/admin-general': ['admin'],
        '/logout': null, // visible para todos
      };
      return state.items.filter(item => {
        const allowed = routeRoleMap[item.to];
        if (allowed === null || allowed === undefined) return true;
        return allowed.some(r => roles.includes(r));
      });
    },
    linksUsuario:(state)=>{
      return state.itemsUsuario
    },
    linksStore:(state)=>{
      return state.itemsStore
    },
    cantidadCarrito:(state)=>{
      return state.carrito.reduce((acc, item) => acc + item.cantidad, 0)
    },
    totalCarrito:(state)=>{
      return state.carrito.reduce((acc, item) => acc + (item.cantidad * parseFloat(item.producto.pvu || 0)), 0)
    },
    estaLogueado:(state)=>{
      return state.logueado
    },
    identificadorUsuario:(state)=>{
      return state.identificadorUsuario
    },
    linkPhotoUsuario:(state)=>{
      return state.linkPhotoUsuario
    },
    userRoles:(state)=>{
      return state.userRoles
    }

  },
  mutations: {
    setDrawer:(state,payload)=>(state.drawer=payload),
    toggleDrawer:state=>(state.drawer=!state.drawer),
    setUsuario(state, usuario) {
      state.usuario = usuario;
    },
    agregarAlCarrito(state, { producto, cantidad }) {
      const stock = parseInt(producto.cantidad_total) || 0;
      // Clamp incoming quantity to [1, stock]
      const cantidadClamped = Math.min(Math.max(cantidad, 1), stock);
      const existente = state.carrito.find(item => item.producto.id === producto.id);
      if (existente) {
        // Sum and clamp accumulated quantity to stock
        existente.cantidad = Math.min(existente.cantidad + cantidadClamped, stock);
      } else {
        state.carrito.push({ producto, cantidad: cantidadClamped });
      }
    },
    quitarDelCarrito(state, productoId) {
      state.carrito = state.carrito.filter(item => item.producto.id !== productoId);
    },
    actualizarCantidadCarrito(state, { productoId, cantidad }) {
      const item = state.carrito.find(i => i.producto.id === productoId);
      if (item) {
        const stock = parseInt(item.producto.cantidad_total) || 0;
        // Clamp to [1, stock]
        item.cantidad = Math.min(Math.max(cantidad, 1), stock);
      }
    },
    vaciarCarrito(state) {
      state.carrito = [];
    },
    setLogueado(state, val) {
      state.logueado = val;
    },
    setIdentificador(state, val) {
      state.identificadorUsuario = val;
      localStorage.setItem('identificador', val || '');
    },
    setLinkPhoto(state, val) {
      state.linkPhotoUsuario = val;
      localStorage.setItem('linkPhoto', val || '');
    },
    setRoles(state, val) {
      state.userRoles = val || [];
      localStorage.setItem('roles', JSON.stringify(state.userRoles));
    }
  },
  actions: {
  },
  modules: { 
   
  },
  plugins: [carritoPlugin]
})


